import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';
import { IBranchById } from '../interfaces';

export type IGetBranchByIdRepoResponse = IRepoResponse<200, IBranchById> | IRepoResponse<400 | 500, string>;

export type IGetBranchByIdRepo = IRepo<[number | string], IGetBranchByIdRepoResponse>;

export const GetBranchByIdRepoType = Symbol.for('GetBranchByIdRepo');

@bind(GetBranchByIdRepoType)
export class GetBranchByIdRepo implements IGetBranchByIdRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(id: number | string) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/branches/info', { branch_id: id }) });

      if (result.status === 200) {
        const data: IBranchById = result.data.data;

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
